let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("p8dZ1")).then(() => parcelRequire('l3z6A'));